import { render, staticRenderFns } from "./ProfileMobile.vue?vue&type=template&id=35bf214c&"
import script from "./ProfileMobile.vue?vue&type=script&lang=js&"
export * from "./ProfileMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports